import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ProfileProvider } from './context/ProfileContext';

// Screens
import HomeScreen from './screens/HomeScreen';
import GamesScreen from './screens/GamesScreen';
import MemoryGameScreen from './screens/games/MemoryGameScreen';
import StoriesScreen from './screens/StoriesScreen';
import StoryBuilderScreen from './screens/StoryBuilderScreen';
import DrawingScreen from './screens/DrawingScreen';
import LearningScreen from './screens/LearningScreen';
import LessonScreen from './screens/LessonScreen';
import DiaryScreen from './screens/DiaryScreen';
import MusicScreen from './screens/MusicScreen';
import CookingScreen from './screens/CookingScreen';
import FocusScreen from './screens/FocusScreen';
import ProfileScreen from './screens/ProfileScreen';
// imports
import GuessPictureScreen from './screens/games/GuessPictureScreen';
import MazeScreen from './screens/games/MazeScreen';
import WordScrambleScreen from './screens/games/WordScrambleScreen';
import ColorMatchScreen from './screens/games/ColorMatchScreen';

// routes

import './App.css';

function App() {
  return (
    <ProfileProvider>
      <BrowserRouter>
        <div className="app">
          <Routes>
	<Route path="/games/guess" element={<GuessPictureScreen />} />
<Route path="/games/maze" element={<MazeScreen />} />
<Route path="/games/word" element={<WordScrambleScreen />} />
<Route path="/games/color" element={<ColorMatchScreen />} />
            <Route path="/" element={<HomeScreen />} />
            <Route path="/games" element={<GamesScreen />} />
            <Route path="/games/memory" element={<MemoryGameScreen />} />
            <Route path="/stories" element={<StoriesScreen />} />
            <Route path="/stories/builder" element={<StoryBuilderScreen />} />
            <Route path="/stories/builder/:storyId" element={<StoryBuilderScreen />} />
            <Route path="/creativity" element={<DrawingScreen />} />
            <Route path="/learning" element={<LearningScreen />} />
            <Route path="/learning/:moduleId/:lessonId" element={<LessonScreen />} />
            <Route path="/diary" element={<DiaryScreen />} />
            <Route path="/music" element={<MusicScreen />} />
            <Route path="/cooking" element={<CookingScreen />} />
            <Route path="/focus" element={<FocusScreen />} />
            <Route path="/profile" element={<ProfileScreen />} />
          </Routes>
        </div>
      </BrowserRouter>
    </ProfileProvider>
  );
}

export default App;
